import React from 'react';
import { LineChart } from '../../../../ui-components/data-viz-ui/charts/line-chart/LineChart';
import { OverTimeUnsegmentedLineChartUiComponentProps } from './types';

export const OverTimeUnsegmentedLineChartUiComponent = (
  props: OverTimeUnsegmentedLineChartUiComponentProps
) => {
  return (
    <LineChart
      {...props}
      displayConfig={{ ...props.displayConfig, enableSortOrder: false }}
    />
  );
};
